import GameCard from "./GameCard";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {fetchGameData} from "../config";
import {toCanonicalGamePath} from "../utils/gameRoutes";

export default function GameGrid() {
    const navigate = useNavigate();

    const gridStyle = {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
        gap: "16px",
        padding: "20px 24px",
        borderRadius: 12,
        border: "1px solid rgba(0, 0, 0, 0.1)",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
        backgroundColor: "#fff",
        transition: "all 0.3s ease",
        direction: "rtl",
    };

    const containerStyle = {
        dir: "rtl",
        maxWidth: 1160,
        margin: "0 auto",
        padding: "40px 16px",
    };
    const [games, setGames] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadGameData = async () => {
            try {
                setLoading(true);
                setError(null);

                const games = await fetchGameData({});
                setGames(games);

            } catch (error) {
                console.error('Error loading game data:', error);
                setError('Failed to load game data');
            } finally {
                setLoading(false);
            }
        };

        loadGameData();
    }, []);

    // Express API returns a dict keyed by slug, Django returns a list.
    const entries = Array.isArray(games)
        ? games.map((g) => [g.slug, g])
        : Object.entries(games ?? {});

    return (
        <div style={containerStyle}>
            <div style={gridStyle}>
                {entries.map(([slug, game]) => (
                    <GameCard
                        key={slug}
                        game={game}
                        onAdd={() => navigate(toCanonicalGamePath(slug))}
                    />
                ))}
            </div>
        </div>
    );
}
